import ProductGrid from './ProductGrid';
import type { Product } from '../utils/apiHelpers';

interface ProductsSectionProps {
  title: string;
  products: Product[];
  loading?: boolean;
  viewAllTo?: string;
  reducedSize?: boolean;
}

export default function ProductsSection({
  title,
  products,
  loading = false,
  viewAllTo,
  reducedSize = false,
}: ProductsSectionProps) {
  return (
    <section className="px-4 py-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-4 flex items-center justify-between sm:mb-6">
          <h2 className="text-lg font-semibold text-[var(--foreground)] sm:text-2xl">
            {title}
          </h2>
          {viewAllTo && (
            <a
              href={viewAllTo}
              className="text-xs text-[#fd9e10] hover:underline sm:text-sm"
            >
              View All →
            </a>
          )}
        </div>
        <ProductGrid products={products} loading={loading} reducedSize={reducedSize} />
      </div>
    </section>
  );
}
